import { React, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import MapComponent from "./map";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { FaTrashCan } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import { useAddressList, useDeleteAddress } from "../../hooks/apis/address";
import { toast } from "react-toastify";

const Address_content = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");

  const { data, isLoading, refetch } = useAddressList();

  const {
    mutate,
    isSuccess,
    isLoading: deleteLoading,
    isError,
  } = useDeleteAddress();

  const deleteAddress = (id) => {
    mutate(id);
  };
  const editAddress = (e) => {
    handleOpenModal(e);
  };

  const handleOpenModal = (address) => {
    setSelectedAddress(address);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    refetch();
  };

  useEffect(() => {
    refetch();
    if (isSuccess) {
      toast.success("آدرس شما با موفقیت حذف شد");
    }
  }, [isSuccess]);

  if (isLoading) {
    return (
      <div className="active loading">
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
    );
  }

  return (
    <>
      <div className="addAddressBox" onClick={handleOpenModal}>
        <p style={{ color: "green", margin: "0" }}>ثبت آدرس جدید </p>
      </div>
      {data &&
        data[0]
          .slice(0)
          .reverse()
          .map((e) => {
            return (
              <div
                key={e.id}
                style={{
                  border: "1px solid gray",
                  padding: "10px",
                  borderRadius: "10px",
                }}
                className="my-2"
              >
                <div className="row">
                  <div className="col-lg-10 col-12 my-2">
                    <p className="m-0 " style={{ color: "white" }}>
                      {e.address}
                    </p>
                  </div>
                  <div className="row col-lg-2 col-12 my-2">
                    <div className="col-lg-6 col-2">
                      <FaTrashCan
                        onClick={() => deleteAddress(e.id)}
                        size={20}
                        color="red"
                        style={{ cursor: "pointer" }}
                      />
                    </div>{" "}
                    <div className="col-lg-6 col-2">
                      <FaEdit
                        onClick={() => editAddress(e)}
                        size={20}
                        color="green"
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

      <Modal show={showModal}>
        <Modal.Header className="row">
          <div className="col-3">
            <IoMdCloseCircleOutline
              size={25}
              onClick={handleCloseModal}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="col-7">
            <Modal.Title
              style={{ textAlign: "right", fontSize: "15px", margin: "0" }}
            >
              آدرس جدید
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <MapComponent
            selectedAddress={selectedAddress}
            closeModal={handleCloseModal}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Address_content;
